"use strict";
var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var SymbolTerminalInteractionModel = function (symbolTerminalData, editorModel) {
    var self = this;
    editor_2d.AbstractPosAngleInteractionModel.call(this, symbolTerminalData, editorModel,
        {angle_restriction: [0, 90, 180, 270]});

    this.boundingBox = this.data.boundingBox;

    this.showName = this.shadow("showName",
        function () {
            return self.data.name();
        },
        function (value) {
            return self.data.name(value);
        },
        [this.data.name]
    );

};
lib_core.inherit(SymbolTerminalInteractionModel, editor_2d.AbstractPosAngleInteractionModel);
lib_core.JsonParser.registerClass(SymbolTerminalInteractionModel, "SymbolTerminalInteractionModel");

module.exports = SymbolTerminalInteractionModel;

SymbolTerminalInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = editor_2d.AbstractPosAngleInteractionModel.prototype.getInspectorElements.call(this);

    inspectorElements.input_elements.unshift(
        {
            label      : 'Name',
            type       : ui_extensions.InspectorInputType.TEXT,
            update_while_typing: true,
            datamember : this.showName
        }
    );

    inspectorElements.help_elements = {
        'name': 'Terminal Tool'
    };

    return inspectorElements;
};
